<template>
  <div>
    <div>
      <el-table :data="data" ref="sortTable"  @cell-click="idEvt"    :cell-style="rowStyle"
        style="width: 100%; margin-top:40px; overflow: none;" class="copy"  @sort-change="sortChangeEvt">
        <el-table-column prop="id" label="素材" width="180" align="center" fixed="left"    >
          <template slot-scope="props" >
            <el-image :src="props.row.thumb"  class="img_box"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="kind" width="200" label="作品类型" align="center" sortable="custom"  :sort-orders="orders">
            <template slot-scope="props">
                    <div style="cursor:pointer"   >
                      <el-dropdown trigger="click" @command="activeEvt($event,props.row)"  >
                        <span style="width:100px;display:flex;height:22px;justify-content: center;"  @click="activeTextEvt(props.row)"   class="el-dropdown-link  white_over" >
                        <span v-if="props.row.kind == 1">Interior</span>
                        <span v-else-if="props.row.kind == 2">Exterior</span>
                        <span v-else-if="props.row.kind == 3">Animation</span>
                        <span v-else-if="props.row.kind == 4">VR360</span>
                          <i class="el-icon-caret-bottom"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item :disabled="props.row.kind == '1'" command="1">Interior</el-dropdown-item>
                          <el-dropdown-item :disabled="props.row.kind == '2'" command="2">Exterior</el-dropdown-item>
                          <el-dropdown-item :disabled="props.row.kind == '3'" command="3">Animation</el-dropdown-item>
                            <el-dropdown-item :disabled="props.row.kind == '4'" command="4">VR360</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </template>
        </el-table-column>
        <el-table-column prop="firm" width="200" label="公司" align="center" sortable="custom" :sort-orders="orders">
             <template slot-scope="props" style="width: 200px;">
                  <el-input v-model="props.row.firm" @change="getList(props.row)"></el-input>
              </template>
        </el-table-column>
        <el-table-column prop="project" width="500" label="项目名" align="center" sortable="custom" :sort-orders="orders">
            <template slot-scope="props" style="width: 200px;">
                <el-input  v-model="props.row.project" @change="getList(props.row)"></el-input>
            </template>
        </el-table-column>
         <el-table-column prop="read" label="访问数量" align="center" width="200"  sortable="custom"  class-name="mahss" :sort-orders="orders">
        </el-table-column>
        <el-table-column prop="create_time" label="上传时间" align="center" width="200"  sortable="custom"  class-name="mahss" :sort-orders="orders">
        </el-table-column>
        <el-table-column prop="height" label="尺寸" align="center" width="200"  sortable="custom"  class-name="mahss" :sort-orders="orders">
               <template slot-scope="props" >
                    <span>{{ props.row.width }} * {{  props.row.height }}</span>
                </template>
          </el-table-column>
           <el-table-column prop="url" label="链接" align="center" width="500"   class-name="mahss">
            <template slot-scope="props" >
                <el-input  v-model="props.row.url" @change="getList(props.row)"  :value="props.row.url"> </el-input>
              </template>
          </el-table-column>
          <el-table-column prop="" label="" align="left"  >
          </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>

import { EditApi,  } from "../api/work/index"

  export default {
    props: ["data", "num" ,],
    data() {
      return {
        header: true,
        src: "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",

        //查询数据
        checkInput: "",

        //序列前后数据
        behindOrderInput: "",
        frontOrderInput: "",
        //选择作者数据
        authorInput: "",
        //分页输入框数据
        paginationInput: 10,
        currentPage1: 1,
        //分页总数据
        total: 100,
        pickerOptions: {
          shortcuts: [
            {
              text: "今天",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "本周",
              onClick(picker) {
                const current = new Date();
                let nowDayOfWeek = current.getDay();
                if (nowDayOfWeek === 0) nowDayOfWeek = 7;
                const dayNum = 1 * 24 * 60 * 60 * 1000;
                const firstDate = new Date(current.valueOf() - (nowDayOfWeek - 1) * dayNum);
                const lastDate = new Date(new Date(firstDate).valueOf() + 6 * dayNum);
                picker.$emit("pick", [firstDate, lastDate]);
              },
            },
            {
              text: "当月",
              onClick(picker) {
                const date = new Date();
                const year = date.getFullYear();
                const month = date.getMonth();
                let thisMonthStartDate = new Date(year, month, 1);
                let thisMonthEndDate = new Date(year, month + 1, 0);
                picker.$emit("pick", [thisMonthStartDate, thisMonthEndDate]);
              },
            },
            {
              text: "当年",
              onClick(picker) {
                var tYear = new Date().getFullYear();
                var startTime = new Date(tYear, 0, 1); //当前年第一天
                var endTime = new Date(tYear, 11, 31); //当前年最后一天
                picker.$emit("pick", [startTime, endTime]);
              },
            },
            {
              text: "昨天",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                picker.$emit("pick", [start, start]);
              },
            },
            {
              text: "上周",
              onClick(picker) {
                const current = new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000);
                let nowDayOfWeek = current.getDay();
                let diffToMonday =
                  current.getDate() - nowDayOfWeek + (nowDayOfWeek === 0 ? -6 : 1);
                const firstDate = new Date(current.setDate(diffToMonday));
                const lastDate = new Date(current.setDate(diffToMonday + 6));
                picker.$emit("pick", [firstDate, lastDate]);
              },
            },
            {
              text: "上月",
              onClick(picker) {
                var now = new Date();
                var fd = new Date(now.getFullYear(), now.getMonth() - 1, 1);
                var ed = new Date(now.getFullYear(), now.getMonth(), 0);
                picker.$emit("pick", [fd, ed]);
              },
            },
            {
              text: "去年",
              onClick(picker) {
                var tYear = new Date().getFullYear() - 1;
                var startTime = new Date(tYear, 0, 1);
                var endTime = new Date(tYear, 11, 31); //当前年最后一天
                picker.$emit("pick", [startTime, endTime]);
              },
            },
          ],
        },
        value2: "",
        input: "",
        editShowInp: null,
        tableData: [],
        selectedId:null,
        orders: ['descending', 'ascending', null],
        kind_one:null,
        num_one:null,
        localData: this.data
      };
    },
    created() { },

    methods: {
       resetSort() {
      // 清除排序
        this.$refs.sortTable.clearSort();
      },
      cleanUpEvt() { },
      limitEvt() { },

      handleCurrentChange() { },
      //
      rowStyle({ row, column, rowIndex, columnIndex }) {
      },
      idEvt( row, column, rowIndex, columnIndex ){
        this.selectedId = [row.id]; // 将拿到的值变成一个数组
        console.log(this.selectedId,1231);

      },
      //列表排序
      sortChangeEvt(row) {
        let a = {
          orWhere:row.prop,
        }
        if (row.order === 'ascending') {
          a.order = 'asc';
        } else if (row.order === 'descending') {
          a.order = 'desc';
        }
        this.$emit('Min_BOX' , a  )
      },

      editInpBlurEvt() {
        this.editShowInp = null;
      },
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          for (let key in this.$props.num) {
            if (column.property == key) {
              sums[index] = this.$props.num[key];
            }
          }
        });
        return sums;
      },
      getList(row){
          EditApi({
            firm: row.firm,
            project: row.project,
            url: row.url,
            ids: this.selectedId,
            kind:this.kind_one,
          }).then((res) => {
            if (res.code == 1000) {
                this.$messages.success('保存成功')
            }else{
              alert(res.msg)
            }
          })
      },
    activeTextEvt(res) {
      this.activeId = res.id;
    },
    activeEvt(res,row) {
      let str = "";
      this.num_one = res
      switch (this.num_one) {
        case "1":
          str = "Interior";
          break;
        case "2":
          str = "Exterior";
          break;
        case "3":
          str = "Animation";
          break;
        case "4":
        str = "VR360";
        break;
      }
      EditApi({
        ids: this.activeId,
        kind: this.num_one,
      }).then((e) => {
       this.localData = this.$props.data.map((val) => {
          if (val.id == this.activeId) {
              val.kind = this.num_one;
          }
          return val;
        });
      });
    },
    },
  };
</script>

<style lang="less" scoped>
  // @import url("../style/space.less");
  @import url("../style/list.less");

  .search-box {
    width: calc(100% - 190px);
    min-width: 1200px;
    height: 90px;
    background: #fff;
    padding: 10px;
    position: fixed;
    top: 60px;
    z-index: 1123;
    visibility: inherit;
    /*box-shadow: 0px 10px 10px 1px rgba(226, 226, 226, 0.4);*/
    transition: all 0.8s ease 0.4s;
  }

  .search-box1 {
    height: 0;
    visibility: hidden;
  }

  .caoz {
    margin-top: 8px;
    display: flex;
  }

  .block {
    position: absolute;
    margin-top: 9px;
    top: 0;
    right: 3%;
    transition: all 0.2s ease 0.5s;
  }

  .block1 {
    visibility: hidden;
  }

  .block1>div {
    display: none;
  }

  .all_text {
    background-color: #409eff;
    font-size: 13px;
    color: #fff;
    cursor: pointer;
    padding: 5px 20px;
    border-radius: 3px;
  }

  .demo-table-expand {
    background-color: #f2f2f2;
    font-size: 0;
  }

  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }

  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    padding: 0 20px;
    width: 30%;
  }

  .name_box {
    display: flex;
    justify-content: center;
    align-items: center;

    i {
      cursor: pointer;
      display: none;
    }
  }

  .name_box:hover>i {
    display: block;
  }
  .img_box{
    width: 150px;
    height: 120px;
    /deep/.el-image__inner{
      object-fit: contain  ;
    }
  }



  /*
/deep/.el-table__body-wrapper {
  margin-top: var(--body);
}

/deep/.el-table__footer-wrapper {
  position: fixed;
  top: var(--footer);
  transition: all 1s ease 0.15s;
  z-index: 999;
}

/deep/.el-table__header-wrapper {
  position: fixed;
  top: var(--header);
  transition: all 1s ease 0.15s;
  z-index: 999;
} */

  .rowClassOne {
    background-color: #e7ecff;
  }

  .rowClassTwo {
    color: #222222;
    background-color: #1c43ce;
  }

  .rowClassThree {
    background-color: #6a88f1;
  }

  /* 需要根据媒体查询更改的样式 */
  .main_header {
    display: flex;
    justify-content: space-between;
    height: 90px;
    position: fixed;
    width: 90%;
    z-index: 111;
  }

  /* 需要根据媒体查询更改的样式 */
  .changing-box {
    position: absolute;
    top: 35px;
    right: 1.2%;
  }

  /* 需要根据媒体查询更改的样式 */
  .main_center {
    min-width: 500px;
    display: flex;
    justify-content: end;
    margin-top: 10px;
    margin-right: 17px;
  }
  .span_box_one{
    position: absolute;
    z-index: 1000;
    left:255px;
    top: 125px;
    font-size: 14px;
  }
  /deep/ .flex-images {
    width: 83.5%;
  }

  /deep/ .el-table__footer-wrapper {
    position: fixed !important;
    top: 170px ;
  }
  /deep/.el-table__body-wrapper{
      height: calc(100vh - 270px) ;
  }
  /deep/.el-table__fixed{
    height: calc(100vh - 30px);
  }
/deep/.el-table__body-wrapper{
  overflow: auto;
}
  .el-main{
    min-width: 1200px !important;
  }
/deep/[class^=el-icon-]{
  margin-top: 3px;
}

</style>



// WEBPACK FOOTER //
// src/components/list.vue